import React from "react";

/* ------------------------------------------------------------------ */
/*  Shield mark only (no wordmark) — for centered logo spots like the   */
/*  auth card. Replaces the retired sift-app-icon.png.                  */
/* ------------------------------------------------------------------ */
export function SiftMark({ size = 56, onDark = false }) {
  const shieldStroke = onDark ? "var(--on-dark)" : "var(--ink)";
  const brand = onDark ? "var(--gold-soft)" : "var(--brand)";
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" role="img" aria-label="Sift Careers" style={{ flex: "0 0 auto" }}>
      <path
        d="M16 2.5l11 3.6v8.2c0 7.2-4.7 12.4-11 15.2C9.7 26.7 5 21.5 5 14.3V6.1L16 2.5z"
        stroke={shieldStroke}
        strokeWidth="1.6"
        strokeLinejoin="round"
        fill="none"
      />
      <text
        x="16" y="21.5" textAnchor="middle"
        fontFamily="var(--font-display, 'Bodoni Moda', serif)"
        fontStyle="italic" fontWeight="600" fontSize="16" fill={brand}
      >
        S
      </text>
    </svg>
  );
}

/* ------------------------------------------------------------------ */
/*  Sift wordmark for the LIGHT design system.                         */
/*  The shipped sift-logo.png is white art on transparent — invisible  */
/*  on the ivory canvas. Per the design system the nav/footer logo is  */
/*  a shield mark + "Sift" (ink) / "Careers" (evergreen). Built in      */
/*  markup so it scales crisply and recolors for dark surfaces.        */
/* ------------------------------------------------------------------ */
export default function SiftWordmark({ size = 30, onDark = false }) {
  const ink = onDark ? "var(--on-dark)" : "var(--ink)";
  const brand = onDark ? "var(--gold-soft)" : "var(--brand)";
  const shieldStroke = onDark ? "var(--on-dark)" : "var(--ink)";

  return (
    <span
      style={{ display: "inline-flex", alignItems: "center", gap: 10, lineHeight: 1 }}
      aria-label="Sift Careers"
    >
      {/* Shield mark with a Bodoni italic S */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        aria-hidden="true"
        style={{ flex: "0 0 auto" }}
      >
        <path
          d="M16 2.5l11 3.6v8.2c0 7.2-4.7 12.4-11 15.2C9.7 26.7 5 21.5 5 14.3V6.1L16 2.5z"
          stroke={shieldStroke}
          strokeWidth="1.6"
          strokeLinejoin="round"
          fill="none"
        />
        <text
          x="16"
          y="21.5"
          textAnchor="middle"
          fontFamily="var(--font-display, 'Bodoni Moda', serif)"
          fontStyle="italic"
          fontWeight="600"
          fontSize="16"
          fill={brand}
        >
          S
        </text>
      </svg>

      <span
        style={{
          fontFamily: "var(--font-sans, 'Instrument Sans', sans-serif)",
          fontWeight: 700,
          fontSize: size * 0.6,
          letterSpacing: "-0.01em",
        }}
      >
        <span style={{ color: ink }}>Sift</span>{" "}
        <span style={{ color: brand }}>Careers</span>
      </span>
    </span>
  );
}
